module.exports = __webpack_public_path__ + "static/2_1_chicken-crossing-2_BG-3b8ab34b7d7cd4ca7a8aab8b2d301448.svg";